export const MAP_REDUCER_NAMES = {
  SETTINGS: 'settings',
  CONTEXT_MENU: 'context_menu',
  TOOLS: 'tools',
};
